module.exports = __webpack_public_path__ + "static/fonts/Inter-Regular.079af0e2.ttf";